var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"text-xl leading-none"},[(_vm.enabled)?_c('a',{class:[isExactActive ? 'text-white' : _vm.inactiveClasses, _vm.defaultClasses],attrs:{"href":href},on:{"click":navigate}},[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")]):_c('span',{class:[_vm.defaultClasses, 'cursor-not-allowed opacity-40']},[_vm._v(_vm._s(_vm.name))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }